import styled, { keyframes } from 'styled-components'

const showIcons = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

const showHideTooltip = keyframes`
  0%{
    opacity: 0;
    transform: translateY(10px);
    display: block;
  }
  5%{
    opacity: 1;
    transform: translateY(0px);
  }
  95%{
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    display: none;
  }
`

export const StyledDivPlayer = styled.div`
  margin-top: 18px;
  display: flex;
  align-items: center;
  pointer-events: all;
`;

export const StyledMusicPlayer = styled.div`
  width: 180px;
  height: 30px;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    width: 140px;
    
    svg {
      width: .8em;
      height: .8em;
    }
  }
`;

export const StyledBorder = styled.div`
  border-top: 1px solid #fff;
`;

export const StyledDivIcons = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  cursor: pointer;

  svg {
    opacity: 0;
    animation: ${showIcons} .4s ease-out forwards;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 8px;
  letter-spacing: 1px;
  top: -24px;
  right: 4px;
  width: auto;
  min-width: 100px;
  color: #FFF;
  padding: 2px 6px;
  border-radius: 4px;
  height: 20px;
  background: rgba(17, 36, 38, 0.8);

  animation: ${showHideTooltip} 3s ease-in-out forwards;

  &:after{
    content: '';
    position: absolute;
    left: 50%;
    top: 100%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid rgba(17, 36, 38, 0.8);
  }
`
